import { all, fork, put, takeEvery } from "redux-saga/effects";

import {

    // Package Management
    SETTING_LOAD_PACKAGE_CATEGORY,
    SETTING_CREATE_PACKAGE_CATEGORY,
    SETTING_UPDATE_PACKAGE_CATEGORY,
    SETTING_DELETE_PACKAGE_CATEGORY,

    SETTING_LOAD_PACKAGE,
    SETTING_CREATE_PACKAGE,
    SETTING_UPDATE_PACKAGE,
    SETTING_DELETE_PACKAGE,

    SETTING_UPDATE_PACKAGE_STATUS,
    // END Package Management

} from "../../actions";

import {
    // Package Management
    settingGetPackageCategory,
    settingAddPackageCategory,
    settingUpdatePackageCategory,
    settingDeletePackageCategory,

    settingGetPackage,
    settingAddPackage,
    settingUpdatePackage,
    settingDeletePackage,
    settingUpdateChangeStatusPackage,

    // END Package Management

} from "../../../helpers/setting-api";

import {
    getPackageCategory,
    getPackageCategorySuccess,
    getPackage,
    getPackageSuccess,
} from "./actions";

import { NotificationManager } from '../../../components/common/react-notifications';

const PullNotificationManager = async (text) => {
    // eslint-disable-next-line no-return-await
    await NotificationManager.warning(text, 'Error', 3000, null, null, '');
}

// Package Management
function* settingManagementLoadPackageCategory({ payload, token }) {
    try {
        const dataRes = yield settingGetPackageCategory(payload, token);
        if (dataRes.status === 'success') {
            // let list = [];
            // const dataFilter = dataRes.data.filter(el => el.name_department === "Owner")
            // const allDataFilter = dataRes.data.filter(el => el.name_department !== "Owner")
            // const checkDataFilter = [...dataFilter || (null), ...allDataFilter || dataRes.data]
            const list = dataRes.data.map(item => (
                {
                    ...item,
                    label: item.name_package_category,
                    value: item.id_package_category,
                }
            ));
            yield put(getPackageCategorySuccess(dataRes.data, list));
        } else
            if (dataRes.status === 'error' && dataRes.auth === false) {
                yield PullNotificationManager("TIME OUT! Please Login again.")
                // yield put(settingErrorMessage("TIME OUT! Please Login again."))
            } else {
                yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
                // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
            }
    } catch (error) {
        yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
        // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
    }
}

function* settingManagementAddPackageCategory({ payload, token }) {
    try {
        const dataRes = yield settingAddPackageCategory(payload, token);
        if (dataRes.status === 'success') {
            yield put(getPackageCategory({ spa_id: payload.spa_id }, token));
        } else
            if
                (dataRes.status === 'error' && dataRes.err.code === 'ER_DUP_ENTRY') {
                yield PullNotificationManager("Oops! The data name is duplicated. Please change the data name.")
                // yield put(settingErrorMessage("Oops! The data name is duplicated. Please change the data name."));
            }

            else if (dataRes.status === 'error' && dataRes.auth === false) {
                yield PullNotificationManager("TIME OUT! Please Login again.")
                // yield put(settingErrorMessage("TIME OUT! Please Login again."))
            }
            else {
                yield PullNotificationManager(`${dataRes.msg}`);
            }

    } catch (error) {
        yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
        // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
    }
}

function* settingManagementUpdatePackageCategory({ payload, token }) {
    try {
        const dataRes = yield settingUpdatePackageCategory(payload, token);
        if (dataRes.status === 'success') {
            yield put(getPackageCategory({ spa_id: payload.spa_id }, token));
            yield put(getPackage({ spa_id: payload.spa_id }, token));
            // yield put(getPosition({ spa_id: payload.spa_id }, token));
            // yield put(getPosition({ idHotel }, token));
            // yield put(getUser());
        } else
            if (dataRes.status === 'error' && dataRes.err.code === 'ER_DUP_ENTRY') {
                yield PullNotificationManager("Oops! The data name is duplicated. Please change the data name.")
                // yield put(settingErrorMessage("Oops! The data name is duplicated. Please change the data name."));
            }
            else if (dataRes.status === 'error' && dataRes.auth === false) {
                yield PullNotificationManager("TIME OUT! Please Login again.")
                // yield put(settingErrorMessage("TIME OUT! Please Login again."))
            } else {
                yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
                // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
            }
    }
    catch (error) {
        yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
        // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
    }
}

function* settingManagementDeletePackageCategory({ payload, token }) {
    const { items } = payload;
    try {
        const dataRes = yield settingDeletePackageCategory(items, token);
        if (dataRes.status === 'success') yield put(getPackageCategory({ spa_id: payload.spa_id }, token));
        else
            if (dataRes.status === 'error' && dataRes.auth === false) {
                yield PullNotificationManager("TIME OUT! Please Login again.")
                // yield put(settingErrorMessage("TIME OUT! Please Login again."))
            }
            else if (dataRes.err.code === "ER_ROW_IS_REFERENCED_2") {
                yield PullNotificationManager("RoleCategory is used.");
            } else {
                yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
                // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
            }
    }
    catch (error) {
        console.log('error', error)
        yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
        // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
    }
}

function* settingManagementLoadPackage({ payload, token }) {
    try {
        const dataRes = yield settingGetPackage(payload, token);
        if (dataRes.status === 'success') {
            // const dataFilter = dataRes.data.filter(el => el.name_position === "Owner")
            // const allDataFilter = dataRes.data.filter(el => el.name_position !== "Owner")
            // const checkDataFilter = [...dataFilter || (null), ...allDataFilter || dataRes.data]
            const list = dataRes.data.map(item => (
                {
                    ...item,
                    label: item.name_package,
                    value: item.id_package,
                }
            ));
            yield put(getPackageSuccess(dataRes.data, list));
        } else
            if (dataRes.status === 'error' && dataRes.auth === false) {
                yield PullNotificationManager("TIME OUT! Please Login again.")
                // yield put(settingErrorMessage("TIME OUT! Please Login again."))
            } else {
                yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
                // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
            }
    } catch (error) {
        yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
        // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
    }
}

function* settingManagementAddPackage({ payload, token }) {
    try {
        const dataRes = yield settingAddPackage(payload, token);
        if (dataRes.status === 'success') {
            yield put(getPackage({ spa_id: payload.spa_id }, token));
        } else
            if
                (dataRes.status === 'error' && dataRes.err.code === 'ER_DUP_ENTRY') {
                yield PullNotificationManager("Oops! The data name is duplicated. Please change the data name.")
                // yield put(settingErrorMessage("Oops! The data name is duplicated. Please change the data name."));
            }

            else if (dataRes.status === 'error' && dataRes.auth === false) {
                yield PullNotificationManager("TIME OUT! Please Login again.")
                // yield put(settingErrorMessage("TIME OUT! Please Login again."))
            }
            else {
                yield PullNotificationManager(`${dataRes.msg}`);
            }

    } catch (error) {
        yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
        // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
    }
}

function* settingManagementUpdatePackage({ payload, token }) {
    try {
        const dataRes = yield settingUpdatePackage(payload, token);
        if (dataRes.status === 'success') {
            yield put(getPackage({ spa_id: payload.spa_id }, token));
            // yield put(getPackageCategory({ spa_id: payload.spa_id }, token));
            // yield put(getPosition({ idHotel }, token));
            // yield put(getUser());
        } else
            if (dataRes.status === 'error' && dataRes.err.code === 'ER_DUP_ENTRY') {
                yield PullNotificationManager("Oops! The data name is duplicated. Please change the data name.")
                // yield put(settingErrorMessage("Oops! The data name is duplicated. Please change the data name."));
            }
            else if (dataRes.status === 'error' && dataRes.auth === false) {
                yield PullNotificationManager("TIME OUT! Please Login again.")
                // yield put(settingErrorMessage("TIME OUT! Please Login again."))
            } else {
                yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
                // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
            }
    }
    catch (error) {
        yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
        // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
    }
}

function* settingManagementChangeStatusPackage({ payload, token }) {
    try {
        const dataRes = yield settingUpdateChangeStatusPackage(payload, token);
        if (dataRes.status === 'success') {
            yield put(getPackage({ spa_id: payload.spa_id }, token));

        } else
            if (dataRes.status === 'error' && dataRes.err.code === 'ER_DUP_ENTRY') {
                yield PullNotificationManager("Oops! The data name is duplicated. Please change the data name.")
                // yield put(settingErrorMessage("Oops! The data name is duplicated. Please change the data name."));
            }
            else if (dataRes.status === 'error' && dataRes.auth === false) {
                yield PullNotificationManager("TIME OUT! Please Login again.")
                // yield put(settingErrorMessage("TIME OUT! Please Login again."))
            } else {
                yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
                // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
            }
    }
    catch (error) {
        yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
        // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
    }
}

function* settingManagementDeletePackage({ payload, token }) {
    const { items } = payload;
    try {
        const dataRes = yield settingDeletePackage(items, token);
        if (dataRes.status === 'success') yield put(getPackage({ spa_id: payload.spa_id }, token));
        else
            if (dataRes.status === 'error' && dataRes.auth === false) {
                yield PullNotificationManager("TIME OUT! Please Login again.")
                // yield put(settingErrorMessage("TIME OUT! Please Login again."))
            }
            else if (dataRes.err.code === "ER_ROW_IS_REFERENCED_2") {
                yield PullNotificationManager("RoleCategory is used.");
            } else {
                yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
                // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
            }
    }
    catch (error) {
        console.log('error', error)
        yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
        // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
    }
}

// END Package Management

// Package Management
export function* watchLoadPackageCategory() {
    yield takeEvery(
        SETTING_LOAD_PACKAGE_CATEGORY,
        settingManagementLoadPackageCategory
    );
}
export function* watchAddPackageCategory() {
    yield takeEvery(
        SETTING_CREATE_PACKAGE_CATEGORY,
        settingManagementAddPackageCategory
    );
}
export function* watchUpdatePackageCategory() {
    yield takeEvery(
        SETTING_UPDATE_PACKAGE_CATEGORY,
        settingManagementUpdatePackageCategory
    );
}
export function* watchDeletePackageCategory() {
    yield takeEvery(
        SETTING_DELETE_PACKAGE_CATEGORY,
        settingManagementDeletePackageCategory
    );
}

export function* watchLoadPackage() {
    yield takeEvery(
        SETTING_LOAD_PACKAGE,
        settingManagementLoadPackage
    );
}
export function* watchAddPackage() {
    yield takeEvery(
        SETTING_CREATE_PACKAGE,
        settingManagementAddPackage
    );
}
export function* watchUpdatePackage() {
    yield takeEvery(
        SETTING_UPDATE_PACKAGE,
        settingManagementUpdatePackage
    );
}
export function* watchChangeStatusPackage() {
    yield takeEvery(
        SETTING_UPDATE_PACKAGE_STATUS,
        settingManagementChangeStatusPackage
    );
}
export function* watchDeletePackage() {
    yield takeEvery(
        SETTING_DELETE_PACKAGE,
        settingManagementDeletePackage
    );
}

// END Package Management

export default function* rootSaga() {
    yield all([
        //  Package Management 
        fork(watchLoadPackageCategory),
        fork(watchAddPackageCategory),
        fork(watchUpdatePackageCategory),
        fork(watchDeletePackageCategory),

        fork(watchLoadPackage),
        fork(watchAddPackage),
        fork(watchUpdatePackage),
        fork(watchChangeStatusPackage),
        fork(watchDeletePackage),

    ])
}